import { useCallback } from 'react'

import { validatePhoneNumbers } from '@/features/domain/order/actions/validatePhoneNumbers'
import { useAppDispatch } from '@/store'

import { Texts } from '../../../../hooks/useTexts'

export function usePhoneValidation() {
  const dispatch = useAppDispatch()

  return useCallback(
    async (texts: Texts, phoneNumber: string) => {
      const companyPhoneInvalid = {
        id: 'companyPhoneInvalid',
        field: 'companyPhone',
        message: texts.validations.companyPhoneInvalidFormat,
      }

      const empty = phoneNumber.trim().length === 0

      if (!empty) {
        // Server validation
        const thunkResult = await dispatch(validatePhoneNumbers([phoneNumber]))

        if (!validatePhoneNumbers.fulfilled.match(thunkResult)) {
          throw new Error(thunkResult.payload?.message ?? 'Internal error')
        }

        if (!thunkResult.payload[phoneNumber]) {
          return {
            [companyPhoneInvalid.id]: companyPhoneInvalid,
          }
        }
      }

      return {
        [companyPhoneInvalid.id]: undefined,
      }
    },
    [dispatch],
  )
}
